import React, { useState, useEffect } from "react";
import "./demo.css";
import { useLocation, useNavigate } from "react-router-dom";
import { database } from "../../database/firebase";
import { getFirestore, doc, updateDoc, getDoc, setDoc, collection, query, where, getDocs, serverTimestamp } from "firebase/firestore";
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback

function Demo({ updateHeader }) {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [themeData, setThemeData] = useState(null);
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const [textColor, setTextColor] = useState(null);
    const [alldata, setAllData] = useState(null);
    //const [riddlerusLogo, SetriddlerusLogo] = useState("./img/logo.png");
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    const [riddlerusLogo, setRiddlerusLogo] = useState("/img/logo.png");

    const handleSuccess = (msg) => {
        Swal.fire({
            icon: "success",
            title: "Success!",
            text: msg,
            customClass: { popup: "custom-success-popup" },
        });
    };

    const handleError = (msg) => {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: msg,
            customClass: { popup: "custom-success-popup" },
        });
    };

    useEffect(() => {
        updateHeader({ backButtonRedirect: "/intro" });

        const storedSession = sessionStorage.getItem("userData");
        const storedTheme = sessionStorage.getItem("themeData");

        if (storedSession && storedTheme) {
            const parsedTheme = JSON.parse(storedTheme);
            setThemeData(parsedTheme);
            setUserData(JSON.parse(storedSession));
            setTextColor(parsedTheme.landing_page_title_color);
        } else {
            navigate("/login");
        }
    }, [navigate]);


    useEffect(() => {
        if (themeData) {
            const body = document.body;

            if (body.classList.contains('common-bg')) {
                // Check if it's a mobile device (or you can define your own breakpoint)
                if (window.innerWidth <= 768) {
                    // Apply mobile background
                    //console.log(themeData.background_mob);
                    body.style.backgroundImage = `url(/img/${themeData.main_mob})`;
                } else {
                    // Apply desktop background
                    //console.log(themeData.background_desk);
                    body.style.backgroundImage = `url(/img/${themeData.main_desk})`;
                }
            }
            setRiddlerusLogo(themeData.logo);
        }
    }, [themeData]);


    return (
        <div className="maincontentdemo">

            {
                <div className="login-main-container2" style={{ textAlign: "center" }}>
                    <img src={riddlerusLogo} className="login-logo1" />
                </div>
            }
            {
                <div className="maindemo">
                    <div className="demoleftimg">
                        <img src="/img/1.gif" alt="Host" className="host-image" />
                    </div>
                    <div className="anchorimg">
                        <img src="/img/host.png" alt="Host" className="host-image" />
                    </div>
                    <div className="demorightimg">
                        <img src="/img/2.gif" alt="Host" className="host-image" />
                    </div>
                </div>

            }


        </div>

    );
}

export default Demo;
